angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.offerListController', ['$scope', 'virtoCommerce.marketplaceModule.webApi', 'platformWebApp.dialogService', 'platformWebApp.bladeUtils', 'platformWebApp.uiGridHelper', 'platformWebApp.ui-grid.extension',
        function ($scope, marketplaceApi, dialogService, bladeUtils, uiGridHelper, gridOptionExtension) {
            $scope.uiGridConstants = uiGridHelper.uiGridConstants;
            $scope.hasMore = true;
            $scope.listEntries = [];

            var blade = $scope.blade;
            blade.headIcon = 'fas fa-store';
            blade.showProductName = !blade.productId;
            blade.showOfferStock = !blade.showProductName;

            var bladeNavigationService = bladeUtils.bladeNavigationService;

            blade.refresh = function (needInfinite) {
                blade.isLoading = true;

                var searchCriteria = getSearchCriteria();

                if (blade.searchCriteria) {
                    angular.extend(searchCriteria, blade.searchCriteria);
                }

                marketplaceApi.searchOffers(searchCriteria, function (data) {

                    $scope.pageSettings.totalItems = data.totalCount;

                    $scope.listEntries = $scope.listEntries.concat(data.results);
                    $scope.hasMore = data.results.length === $scope.pageSettings.itemsPerPageCount;
                    if (needInfinite) {
                        $scope.gridApi.infiniteScroll.resetScroll(true, true);
                        $scope.gridApi.infiniteScroll.dataLoaded();
                    }
                    blade.isLoading = false;
                });
            };

            blade.toolbarCommands = [
                {
                    name: "platform.commands.refresh", icon: 'fa fa-refresh',
                    executeMethod: function () {
                        blade.offersRefresh(true);
                    },
                    canExecuteMethod: function () {
                        return true;
                    }
                }
            ];

            blade.offersRefresh = function () {
                $scope.listEntries = [];
                if ($scope.pageSettings.currentPage > 1) {
                    $scope.pageSettings.currentPage = 1;
                } else {
                    blade.refresh(true);
                }
            }

            var setSelectedNode = function (listItem) {
                $scope.selectedNodeId = listItem.id;
            };

            $scope.selectNode = function (listItem) {
                setSelectedNode(listItem);

                $scope.showDetails(listItem);
            }

            $scope.showDetails = function (listItem) {
                var newBlade = {
                    id: 'offerDetails',
                    title: listItem.name,
                    subtitle: 'marketplace.blades.offer-details.subtitle',
                    currentEntity: listItem,
                    controller: 'virtoCommerce.marketplaceModule.offerDetailsController',
                    template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/offer-details.tpl.html'
                };
                bladeNavigationService.showBlade(newBlade, blade);
            };

            $scope.delete = function (data) {
                deleteList([data]);
            };

            var filter = $scope.filter = { keyword: null };

            filter.criteriaChanged = function () {
                blade.offersRefresh();
            };

            $scope.setGridOptions = function (gridId, gridOptions) {
                $scope.gridOptions = gridOptions;
                gridOptionExtension.tryExtendGridOptions(gridId, gridOptions);

                gridOptions.onRegisterApi = function (gridApi) {
                    $scope.gridApi = gridApi;
                    gridApi.core.on.sortChanged($scope, function () {
                        if (!blade.isLoading) {
                            blade.offersRefresh();
                        }
                    });
                    gridApi.infiniteScroll.on.needLoadMoreData($scope, showMore);
                };

                bladeUtils.initializePagination($scope);
            };

            function getSearchCriteria() {
                var searchCriteria = {
                    keyword: filter.keyword ? filter.keyword : undefined,
                    sort: uiGridHelper.getSortExpression($scope),
                    skip: ($scope.pageSettings.currentPage - 1) * $scope.pageSettings.itemsPerPageCount,
                    take: $scope.pageSettings.itemsPerPageCount
                };
                if (blade.productId) {
                    searchCriteria.productId = blade.productId;
                }
                if (blade.sellerProductId) {
                    searchCriteria.sellerProductId = blade.sellerProductId;
                }
                return searchCriteria;
            };

            function showMore() {
                if ($scope.hasMore) {

                    ++$scope.pageSettings.currentPage;
                    $scope.gridApi.infiniteScroll.saveScrollPercentage();
                    $scope.gridApi.infiniteScroll.dataLoaded();
                }
            };
        }
]);
